import { render, staticRenderFns } from "./BasePreparation.vue?vue&type=template&id=c2655af2&"
import script from "./BasePreparation.vue?vue&type=script&lang=js&"
export * from "./BasePreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports